import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function CrohnDisease(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-09-anemia-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Crohn's Disease"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Crohn's disease is <b> a type of inflammatory bowel
                                        disease (IBD)</b>. It causes inflammation of your digestive
                                    tract, which can lead to abdominal pain, severe
                                    diarrhea, fatigue, weight loss and malnutrition.
                                    Inflammation caused by Crohn's disease can involve
                                    different areas of the digestive tract in different people.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Crohn's-Disease/1.png")} alt="Crohn's-Disease" />
                                    </div>
                                </div>

                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <ul className="listUnstyle">
                                    <li>Diarrhea</li>
                                    <li>Fever</li>
                                    <li>Fatigue</li>
                                    <li>Abdominal pain and cramping</li>
                                    <li>Blood in your stool</li>
                                    <li>Mouth sores</li>
                                    <li>Reduced appetite and weight loss</li>
                                    <li>Pain or drainage near or around the anus due to inflammation from a tunnel into the
                                        skin (fistula)</li><li>
                                        <p>
                                            <b>Pain areas:</b>
                                            <br />
                                            in the abdomen, lower abdomen, or rectum
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Pain types:</b>
                                            <br />
                                            can be mild or severe
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Gastrointestinal:</b>
                                            <br />
                                            bloating, bowel obstruction, diarrhoea, nausea, vomiting, or flatulence
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Whole body:</b>
                                            <br />
                                            fatigue, fever, or loss of appetite
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Anal:</b>
                                            <br />
                                            fissures or bleeding
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Also common:</b>
                                            <br />
                                            cramping, depression, flare, mouth ulcer, slow growth, or weight loss
                                        </p>
                                    </li>
                                </ul>
                                <a className="links" href="https://en.wikipedia.org/wiki/Crohn%27s_disease">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default CrohnDisease;